// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main--wrapper {
  height: 100vh; /* Full viewport height */
  width: 100%;   /* Full width of the screen */
  background-color: white;
}

body {
    background-color: white;
}

.main--container {
  margin: 1rem; /* 1rem of space on all sides */
  margin-top: 0;
  width: calc(100% - 2rem); /* 100% width minus 2rem (1rem on each side) */
  height: calc(100vh - 2rem); /* 100% height minus 2rem (1rem on each side) */
  background-color: white; /* Example background color */
  box-sizing: border-box; /* Make sure the padding is included in the width */
  display: flex;
  position: relative;
}

.main--content {
    position: absolute;
    padding-left: 1rem;
    margin-top: 5.5rem;
    z-index: 1;
    width: calc(100% - 22rem);
    max-width: 80rem;
}

.main--flex {
    width: 70%;
    margin-left: auto;
    margin-right: 0;
    min-width: calc(100% - 20rem);
    max-width: calc(100% - 22rem);
}

.sidebar-header a{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.admin--toggleMenuItem {
    cursor: pointer;
}

.admin--toggleMenuItem {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin: 0;
}

.admin--toggleMenuItem p {
    margin: 1rem 0;
}

.admin--toggleMenuItem__icon {
    height: 1.8rem;
    width: 1.8rem;
}

.admin--toggleMenuItem__icon.rotate {
    transform: rotate(90deg);
}

.flexContainer-adminLinks {
    display: none; /* Initially hide the submenu */
    flex-direction: column;
}

.flexContainer-adminLinks.open {
    display: flex; /* Show submenu when the state is 'open' */
    margin-left: 2rem
}

header {
    position: fixed;
    display: flex;
    gap: 2rem;
    align-items: center;
    width: calc(100% - 22rem);
    height: 4.5rem;
    background-color: #e6f2f6;
    z-index: 99;
    margin-left: 1rem;
}

.online--status {
    margin-left: 0.5rem;
    border-radius: 0 1rem 1rem 0;
    padding: 0 2rem;
    width: 10rem;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #f79251;
}

.active--switch {
    display: flex;
    justify-content: center;
    align-items: center;
}

.call--container {
    display: flex;
    width: 50%;
    margin-right: 0;
    margin-left: auto;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    padding-right: 1rem;
}

.call--info {
    margin-right: 2rem;
}

.superadmin--flex {
    display: flex;
    gap: 1rem;
}

.organisation--box {
    width: 50%;
    padding: 1rem;
    background-color: #e6f2f6;
}

.kiosk--box {
    width: 50%;
    padding: 1rem;
    background-color: #e6f2f6;
}

.call--container button {
    height: 100%;
    margin: 0;
}

.pickup--button {
    display: flex;
    gap: 1rem
}

.decline--button {
    display: flex;
    gap: 1rem
}

.sidebar {
    width: 20rem;
    height: calc(100% - 2rem);
    background-color: #e6f2f6;
    color: #024e64;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
}

.sidebar .collegas {
    gap: 1rem;
    background-color: white;
    border: solid 5px #e6f2f6;
    padding: 1rem;
    position: relative;
}

.collegas img {
    position: absolute;
    left: -0.5rem;
    top: -0.5rem;
}

.sidebar .collegas h5 {
    border-bottom: solid #e6f2f6 0.2rem;
    padding-bottom: 1rem;
}

.sidebar .collegas--flex {
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.sidebar button {
    width: 100%;
}

.profile-link {
    text-decoration: none;
}

.profile-flex {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    background-color: white;
    border: solid 5px #e6f2f6;
}

.sidebar-header a{
    text-align: center;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/layouts/BaseLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa,EAAE,yBAAyB;EACxC,WAAW,IAAI,6BAA6B;EAC5C,uBAAuB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;EACE,YAAY,EAAE,+BAA+B;EAC7C,aAAa;EACb,wBAAwB,EAAE,8CAA8C;EACxE,0BAA0B,EAAE,+CAA+C;EAC3E,uBAAuB,EAAE,6BAA6B;EACtD,sBAAsB,EAAE,mDAAmD;EAC3E,aAAa;EACb,kBAAkB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa,EAAE,+BAA+B;IAC9C,sBAAsB;AAC1B;;AAEA;IACI,aAAa,EAAE,0CAA0C;IACzD;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB","sourcesContent":[".main--wrapper {\n  height: 100vh; /* Full viewport height */\n  width: 100%;   /* Full width of the screen */\n  background-color: white;\n}\n\nbody {\n    background-color: white;\n}\n\n.main--container {\n  margin: 1rem; /* 1rem of space on all sides */\n  margin-top: 0;\n  width: calc(100% - 2rem); /* 100% width minus 2rem (1rem on each side) */\n  height: calc(100vh - 2rem); /* 100% height minus 2rem (1rem on each side) */\n  background-color: white; /* Example background color */\n  box-sizing: border-box; /* Make sure the padding is included in the width */\n  display: flex;\n  position: relative;\n}\n\n.main--content {\n    position: absolute;\n    padding-left: 1rem;\n    margin-top: 5.5rem;\n    z-index: 1;\n    width: calc(100% - 22rem);\n    max-width: 80rem;\n}\n\n.main--flex {\n    width: 70%;\n    margin-left: auto;\n    margin-right: 0;\n    min-width: calc(100% - 20rem);\n    max-width: calc(100% - 22rem);\n}\n\n.sidebar-header a{\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.admin--toggleMenuItem {\n    cursor: pointer;\n}\n\n.admin--toggleMenuItem {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n    margin: 0;\n}\n\n.admin--toggleMenuItem p {\n    margin: 1rem 0;\n}\n\n.admin--toggleMenuItem__icon {\n    height: 1.8rem;\n    width: 1.8rem;\n}\n\n.admin--toggleMenuItem__icon.rotate {\n    transform: rotate(90deg);\n}\n\n.flexContainer-adminLinks {\n    display: none; /* Initially hide the submenu */\n    flex-direction: column;\n}\n\n.flexContainer-adminLinks.open {\n    display: flex; /* Show submenu when the state is 'open' */\n    margin-left: 2rem\n}\n\nheader {\n    position: fixed;\n    display: flex;\n    gap: 2rem;\n    align-items: center;\n    width: calc(100% - 22rem);\n    height: 4.5rem;\n    background-color: #e6f2f6;\n    z-index: 99;\n    margin-left: 1rem;\n}\n\n.online--status {\n    margin-left: 0.5rem;\n    border-radius: 0 1rem 1rem 0;\n    padding: 0 2rem;\n    width: 10rem;\n    background-color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #f79251;\n}\n\n.active--switch {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.call--container {\n    display: flex;\n    width: 50%;\n    margin-right: 0;\n    margin-left: auto;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding-right: 1rem;\n}\n\n.call--info {\n    margin-right: 2rem;\n}\n\n.superadmin--flex {\n    display: flex;\n    gap: 1rem;\n}\n\n.organisation--box {\n    width: 50%;\n    padding: 1rem;\n    background-color: #e6f2f6;\n}\n\n.kiosk--box {\n    width: 50%;\n    padding: 1rem;\n    background-color: #e6f2f6;\n}\n\n.call--container button {\n    height: 100%;\n    margin: 0;\n}\n\n.pickup--button {\n    display: flex;\n    gap: 1rem\n}\n\n.decline--button {\n    display: flex;\n    gap: 1rem\n}\n\n.sidebar {\n    width: 20rem;\n    height: calc(100% - 2rem);\n    background-color: #e6f2f6;\n    color: #024e64;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    position: fixed;\n}\n\n.sidebar .collegas {\n    gap: 1rem;\n    background-color: white;\n    border: solid 5px #e6f2f6;\n    padding: 1rem;\n    position: relative;\n}\n\n.collegas img {\n    position: absolute;\n    left: -0.5rem;\n    top: -0.5rem;\n}\n\n.sidebar .collegas h5 {\n    border-bottom: solid #e6f2f6 0.2rem;\n    padding-bottom: 1rem;\n}\n\n.sidebar .collegas--flex {\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.sidebar button {\n    width: 100%;\n}\n\n.profile-link {\n    text-decoration: none;\n}\n\n.profile-flex {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n    background-color: white;\n    border: solid 5px #e6f2f6;\n}\n\n.sidebar-header a{\n    text-align: center;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
